export const LABELS = {
  issueCreateDialogTitleTemplatePane: 'Create new issue',
  issueCreateChooseDiffTemplate: 'Choose a different template',
  issueCreateDialogTitleCreationPane: (
    repoNwo: string,
    templateName: string | undefined,
    relationType: 'issue' | 'sub-issue' = 'issue',
  ) => `Create new ${relationType} in ${repoNwo}${templateName ? `: ${templateName}` : ''}`,
  issueCreateDialogTitleDuplicationPane: (repoNwo: string, relationType: 'issue' | 'sub-issue' = 'issue') =>
    `Duplicate current ${relationType} in ${repoNwo}`,
  issueCreateTitleLabel: 'Add a title',
  issueCreateTitlePlaceholder: 'Title',
  issueCreateBodyLabel: 'Add a description',
  issueCreatedPrefix: 'Issue created ',
  lastIssueCreated: (issueNumber: number) => `Issue #${issueNumber} created`,
  issuesDisabledForRepo: 'Issues are disabled for the selected repository. Please select a different repository.',
  issueBodyPlaceholder: 'Type your description here…',
  issueNumber: (issueNumber: number) => `#${issueNumber}`,
  blankIssueName: 'Blank issue',
  blankIssueDescription: 'Create a new issue from scratch',
  securityPolicyName: 'Report a security vulnerability',
  securityPolicyDescription: 'Please review our security policy for more details',
  editTemplates: 'Edit templates',
  viewTemplates: 'View templates',
  templatesFormsTitle: 'Templates and forms',
  noTemplates: 'No templates available for the current repository',
  discardConfirmation: {
    title: 'Discard changes?',
    content: 'You have unsaved changes. Are you sure you want to discard them?',
    confirm: 'Close and discard',
    cancel: 'Keep editing',
  },
  loadingTooltip: 'Loading...',
  templateId: (template: string) => `template-item-${template}`,
  templateLabelId: (template: string) => `template-item-${template}-label`,
  templateDescriptionId: (template: string) => `template-item-${template}-description`,
  typePickerLabel: 'Type',
  selectIssueTypeLabel: 'create-issue-issue-type-label',
  fileUploadWarning: 'Issue will be created once your upload has completed',
  issueTypeReadOnly: 'You do not have permission to change the type',
  issueTypeReadOnlyReason: 'You need the triage role or higher in this repository to change the issue type.',
  viewProfile: (login: string) => `View ${login}'s profile`,
  copilotCTAButton: 'Write with Copilot',
  copilotCTADialogTitle: 'Navigate to Copilot Chat',
  copilotCTADialogDescription: 'You have unsaved changes. Are you sure you want to discard them?',
  copilotCTADialogCancelButton: 'Keep editing',
  copilotCTADialogContinueButton: 'Go to Copilot',
  copilotGenerateDialogTitle: 'Generate issue content with Copilot',
  copilotGenerateDialogTextareaLabel: 'Additional context (optional)',
  copilotGenerateDialogTextareaPlaceholder: 'Add any additional context to help Copilot generate a better issue...',
  copilotGenerateDialogGenerateButton: 'Generate content',
  copilotGenerateError: 'Failed to generate content with Copilot. Please try again.',
  copilotGenerateValidationWarning:
    'Please provide a title, existing description, or additional context to generate content.',
  backToAllIssues: 'Back to all issues',
  crossRepoIssueDuplicationWarning: (droppedMetadata: string[]) =>
    `This issue is being duplicated across repositories. The following metadata might not be copied: ${droppedMetadata.join(
      ', ',
    )}.`,
  crossRepoIssueDuplicationDefaultWarning:
    'Changing the repository may remove Milestone, Labels, Type, and Assignees from the duplicate issue.',
  setAdditionalFields: 'Set additional issue fields',
  addIssueField: 'Add issue field',
}
